import palette from './palette';

const switchTheme = {
  MuiSwitch: {
    styleOverrides: {
      root: {
        borderRadius: 16,
        height: 31,
        marginRight: 8,
        marginLeft: 2,
        overflow: 'hidden',
        padding: 0,
        width: 51,
      },
      switchBase: {
        padding: 2,
        '&.Mui-checked': {
          color: palette.common.white,
          '& + .MuiSwitch-track': {
            opacity: 1,
          },
        },
        '&.Mui-disabled': {
          color: palette.grey[200],
          boxShadow: '0px 3px 7px 0px rgba(0, 0, 0, 0.12)',
          '& + .MuiSwitch-track': {
            opacity: 1,
          },
          '&.Mui-checked': {
            color: palette.common.white,
            '& + .MuiSwitch-track': {
              backgroundColor: palette.red[100],
            },
          },
        },
      },
      thumb: {
        boxShadow: 'none',
        width: 27,
        height: 27,
      },
      track: {
        backgroundColor: palette.grey[600],
        borderRadius: 16,
        opacity: 1,
        '.Mui-focusVisible + &': {
          outline: '2px solid ' + palette.common.black,
          outlineOffset: '-2px',
        },
      },
    },
  },
};

export default switchTheme;
